/* global axios */

import ApiClient from './ApiClient';

class CannedAudioResponse extends ApiClient {
    constructor() {
        super('canned_audio_responses', { accountScoped: true });
    }

    get({ searchKey, scope } = {}) {
        const params = new URLSearchParams();
        if (searchKey) params.append('search', searchKey);
        if (scope) params.append('scope', scope);
        const query = params.toString();
        const url = query ? `${this.url}?${query}` : this.url;
        return axios.get(url);
    }

    create(formData) {
        return axios.post(this.url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }
}

export default new CannedAudioResponse();
